import React from 'react';

import { Card } from '@atlaskit/smart-card';
import {
	type ActionKeys,
	JIRA_FIND_ISSUES_KEY,
} from '@atlassian/conversation-assistant-message-actions-api/constants';
import {
	type ActionRendererFor,
	type ActionRendererKeyToPayload,
	type ActionWith,
} from '@atlassian/conversation-assistant-message-actions-api/types';
import type { MessageAction } from '@atlassian/conversation-assistant-service-api/types/message-actions';
export const filterJiraFindIssuesActions = (
	actions: MessageAction[],
): ActionWith<ActionRendererKeyToPayload[typeof ActionKeys.JiraFindIssues]>[] => {
	const filteredActions = actions.filter(assertIsJiraFindIssuesAction);
	return filteredActions as ActionWith<
		ActionRendererKeyToPayload[typeof ActionKeys.JiraFindIssues]
	>[];
};

const assertIsJiraFindIssuesAction = (action: MessageAction): MessageAction => {
	if (action.key !== JIRA_FIND_ISSUES_KEY) {
		throw new Error('Invalid action key for JiraFindIssuesAction');
	}
	return action;
};

export const JiraFindIssuesAction = ({
	actions,
}: ActionRendererFor<typeof ActionKeys.JiraFindIssues>): React.JSX.Element | null => {
	const firstAction = actions[0];
	const {
		data: { issues },
	} = firstAction;
	return issues.length > 0 ? (
		<ol>
			{issues.map((issue) => (
				<li key={issue.issueKey}>
					<Card
						url={issue.url}
						appearance="inline"
						onClick={(e) => {
							e.preventDefault();
							window.open(issue.url, '_blank');
						}}
					/>
				</li>
			))}
		</ol>
	) : null;
};
